<template>
  <transition name="modalbg">
    <div @click.self="closeModal" class="modal_container">
      <transition name="modal" v-on:before-leave="modalClose">
        <div v-if="showed" class="modal">
          <div class="caption">
            <div class="title-modal">{{textContent.titleAdd}}</div>
            <div @click="closeModal" class="close"></div>
          </div>
          <div class="modal-scroll" :class="{ 'in-last-tab' : isLastTab }">
            <div class="modal-content">
              <form v-on:submit.prevent="addItem">
                <form-input name="title"></form-input>
                <form-input name="creator"></form-input>
                <form-input name="year"></form-input>
                <form-drop-down title="title" name="author_id" :id="parentId.authors"
                                :url="apiUrls.content"></form-drop-down>
                <div class="checkbox-group">
                  <checkbox name="show_author"></checkbox>
                  <checkbox name="show_date"></checkbox>
                </div>
                <form-file use-case="cover" name="img"></form-file>
                <form-input name="seo_alt"></form-input>
                <p class="subheading">Добавьте аудиофайлы</p>
                <form-audio v-for="(audio, index) of counterAudio" :index="index"></form-audio>
                <div class="buttons-control">
                  <span class="remove" :class="{active: counterAudio > 1}" @click="removeAudio">Удалить</span>
                  <span class="add" @click="counterAudio++">Добавить</span>
                </div>
                <form-text-area name="subtext"></form-text-area>
                <form-text-editor name="text" editor-id="editor"></form-text-editor>
                <form-input name="seo_title"></form-input>
                <form-text-area name="seo_key"></form-text-area>
                <form-text-area name="seo_desc"></form-text-area>
              </form>
            </div>
          </div>
          <div class="buttons">
            <div class="next">
              <button @click="closeModal" class="cancel">{{textContent.cancelButton}}</button>
              <button class="confirm" @click="onAddItem">{{textContent.submitButton}}</button>
            </div>
          </div>
        </div>
      </transition>
    </div>
  </transition>
</template>

<script>
  import IconAlignleft from '@/components/icons/IconAlignleft'
  import IconSignalbars from '@/components/icons/IconSignalbars'
  import IconArrowbold from '@/components/icons/IconArrowbold'
  import FormInput from '@/components/create-form/Input'
  import FormTextArea from '@/components/create-form/TextArea'
  import Calendar from '@/components/create-form/Calendar'
  import FormFile from '@/components/create-form/File'
  import FormDropDown from '@/components/create-form/DropDown'
  import FormTextEditor from '@/components/create-form/TextEditor'
  import FormAudio from '@/components/create-form/Audio'
  import {createNamespacedHelpers} from 'vuex'
  import Tabs from '@/components/create-form/Tabs'
  import Checkbox from '@/components/create-form/Checkbox'

  const {mapMutations, mapActions, mapState, mapGetters} = createNamespacedHelpers('mainPage')

  export default {
    data () {
      return {
        showed: false,
        counterAudio: 1
      }
    },
    computed: {
      ...mapState([
        'textContent',
        'fields'
      ]),
      ...mapGetters([
        'getDataFromEditor',
        'isLastTab'
      ]),
      apiUrls () {
        return this.$store.state.apiUrls
      },
      parentId () {
        return this.$store.state.parentId
      }
    },
    methods: {
      removeAudio () {
        if (this.counterAudio > 1) {
          this.counterAudio--
        }
      },
      ...mapActions([
        'modalClose',
        'addItem',
        'initFields',
        'onNext',
        'onPrev',
        'checkTabAwailability',
        'addToNews'
      ]),
      ...mapMutations([
        'setField',
        'resetTextEditor',
        'setTabs',
        'setCurrentTabId',
        'setFileExtensions'
      ]),
      onAddItem () {
        this.setField({fieldId: 'text', fieldPropertyId: 'value', value: this.fields.text.editor.getData()})
        this.addItem()
        this.addToNews({
          title: this.fields.title.value,
          url: {
            path: 'audioknigi',
            categoryId: null
          },
          img: this.fields.img.value,
          subtext: this.fields.subtext.value
        })
      },
      closeModal () {
        this.showed = false
      }
    },
    mounted () {
      this.showed = true
    },
    created () {
      this.setCurrentTabId(0)
      this.setFileExtensions({img: ['jpg', 'jpeg', 'png', 'gif']})
      this.initFields({
        title: {
          value: '',
          parameterName: 'title',
          name: 'Название книги',
          errorId: null,
          errors: {empty: 'Введите название книги'},
          tabId: 0
        },
        author_id: {
          value: '',
          parameterName: 'author_id',
          name: 'Автор статьи',
          errorId: null,
          isNullable: true,
          errors: {empty: 'Выберите эксперта'},
          tabId: 0,
        },
        creator: {
          value: '',
          parameterName: 'creator',
          name: 'Автор книги',
          errorId: null,
          type: 'object',
          isNullable: true,
          errors: {empty: 'Введите автора книги'},
          tabId: 0
        },
        seo_alt: {
          value: '',
          parameterName: 'seo_alt',
          name: 'Alt',
          errorId: null,
          errors: {empty: 'Напишите alt для картинки'},
          tabId: 0,
          isNullable: true
        },
        year: {
          value: '',
          parameterName: 'year',
          name: 'Год издания',
          errorId: null,
          type: 'object',
          errors: {empty: 'Введите год издания книги'},
          tabId: 0
        },
        show_author: {
          value: true,
          parameterName: 'show_author',
          name: 'Отображать автора',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        show_date: {
          value: true,
          parameterName: 'show_date',
          name: 'Отображать дату',
          errorId: null,
          tabId: 0,
          isNullable: true
        },
        img: {
          value: '',
          parameterName: 'img',
          name: 'Изображение',
          errorId: null,
          errors: {empty: 'Выберите изображение', extension: 'Допустимые расширения: jpg, jpeg, png, gif'},
          fileName: '',
          tabId: 0
        },
        subtext: {
          value: '',
          parameterName: 'subtext',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Введите краткое описание'},
          tabId: 0,
        },
        text: {
          value: '',
          parameterName: 'text',
          name: 'Текст',
          errorId: null,
          errors: {empty: 'Введите текст'},
          tabId: 0,
        },
        seo_title: {
          value: '',
          parameterName: 'seo_title',
          name: 'Название страницы',
          errorId: null,
          errors: {empty: 'Напишите название страницы'},
          tabId: 0
        },
        seo_key: {
          value: '',
          parameterName: 'seo_key',
          name: 'Ключевые слова',
          errorId: null,
          errors: {empty: 'Напишите ключевые слова'},
          tabId: 0,
          isNullable: true
        },
        seo_desc: {
          value: '',
          parameterName: 'seo_desc',
          name: 'Краткое описание',
          errorId: null,
          errors: {empty: 'Напишите краткое описание'},
          tabId: 0
        },
      })
    },
    components: {
      Checkbox,
      IconAlignleft,
      IconSignalbars,
      IconArrowbold,
      FormInput,
      FormTextArea,
      FormFile,
      FormDropDown,
      FormTextEditor,
      Tabs,
      Calendar,
      FormAudio
    }
  }
</script>

<style lang="scss" scoped>
  .modal_container .modal form .dropdown {
    margin: 28px 0;
  }

  .buttons-control {
    display: flex;
  }

  span {
    &.add, &.remove {
      display: block;
      background: #089cd3;
      border: 1px solid #089cd3;
      color: #fff;
      width: max-content;
      border-radius: 30px;
      padding: 10px 34px;
      transition: 0.3s;
      margin-bottom: 20px;
    }

    &.remove {
      background-color: transparent;
      color: #089cd3;
      opacity: 0.3;
      margin-right: 6px;

      &:hover {
        cursor: default;
      }

      &.active {
        opacity: 1;

        &:hover {
          color: white;
          background-color: #089cd3;
          cursor: pointer;
          transition: 0.3s;
        }
      }
    }

    &.add {
      &:hover {
        color: #089cd3;
        background-color: transparent;
        cursor: pointer;
        transition: 0.3s;
      }
    }
  }

  .subheading {
    margin-bottom: 20px !important;
    color: #6e7074;
  }
</style>



// WEBPACK FOOTER //
// src/components/pages/library/audio-books/CreateModal.vue